"use client";
import {
  createItemFile,
  deleteItem,
  fetchData,
  fetchDataNoPag,
  getOneItem,
  updateItemFile,
  updateItemJson,
} from "../../../../Api/hotelEndpoint";
import { createAsyncThunk } from "@reduxjs/toolkit";

/***------------- Get All Hotel Amenity Data ------------- ***/
export const fetchAmenity = createAsyncThunk(
  "hotel/amenity/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const { data, totalPages, totalItems } = await fetchData({
        endpoint: "hotel/amenity/fetchAll",
        ...params,
      });
      return { data, totalPages, totalItems };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- update Amenity Order - API ------------- ***/
export const updateAmenityOrder = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: "hotel/update-amenity-order",
      formData,
    });

    if (data) return formData;
    else throw new Error("Request failed");
  } catch (error) {
    throw error;
  }
};

/***------------- Get All Room Amenities Name ------------- ***/
export const fetchRoomAmenities = async () => {
  try {
    const data = await fetchDataNoPag({
      endpoint: "fetchAllRoomAmenities",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

/***------------- Get One Amenity Data ------------- ***/
export const fetchOneAmenity = createAsyncThunk(
  "hotel/amenity/fetch",
  async ({ id }, { rejectWithValue }) => {
    try {
      const data = await getOneItem(`hotel/amenity/fetch/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Add Hotel Amenity - API ------------- ***/
export const createHotelAmenity = createAsyncThunk(
  "hotel/amenity/create",
  async ({ formData, router }, { rejectWithValue }) => {
    try {
      const data = await createItemFile({
        endpoint: "hotel/amenity/create",
        formData,
      });
      if (data) {
        router("/hotel/amenities");
        return data;
      } else throw new Error("Request failed");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- update Hotel Amenity - API ------------- ***/
export const updateHotelAmenity = createAsyncThunk(
  "hotel/amenity/update",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const data = await updateItemFile({
        endpoint: "hotel/amenity/update",
        formData,
        id: formData._id,
      });
      if (data) return { id: formData._id, data };
      else throw new Error("Request failed");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- Delete Hotel Amenity - API ------------- ***/
export const deleteHotelAmenity = createAsyncThunk(
  "hotel/amenity/delete",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/amenity",
        ...deleteData,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Delete-undo Hotel Amenity - API ------------- ***/
export const deleteUndoHotelAmenity = createAsyncThunk(
  "hotel/amenity/delete-undo",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/amenity",
        ...deleteData,
        undo: true,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
